import { render, staticRenderFns } from "./CardZip.vue?vue&type=template&id=8498b9c8&scoped=true&"
import script from "./CardZip.vue?vue&type=script&lang=js&"
export * from "./CardZip.vue?vue&type=script&lang=js&"
import style0 from "./CardZip.vue?vue&type=style&index=0&id=8498b9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8498b9c8",
  null
  
)

export default component.exports